import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig from '../useGetFetchConfig';
import { DeletionHistory } from '@/api/types/backend-dto-types';

export const useGetDeletedFiles = (matterId: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<DeletionHistory[]>(
    [QueryEntity.DeletedFiles, { matterId }],
    () => {
      return fetch(`${APIBaseChronos}/api/matter/${matterId}/upload-metadata/deleted`, fetchConfigGET).then((res) => {
        return res.json();
      });
    },
    {
      enabled: !!matterId,
      refetchOnWindowFocus: false,
    },
  );
};
